import { render } from "./DriverNewVersionUpload.vue?vue&type=template&id=688f878b"
import script from "./DriverNewVersionUpload.vue?vue&type=script&lang=js"
export * from "./DriverNewVersionUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__